const stopVideo = (fullWidth?: boolean) => {
    const selector = fullWidth ? "product-video--full-width" : "product-video";
    const productVideoIframes = document.querySelectorAll(`iframe.${selector}`);

    productVideoIframes.forEach((iFrameElement) => {
        const iframe = iFrameElement as HTMLIFrameElement;
        if (iframe) {
            const iframeSrc = iframe.src;
            iframe.src = iframeSrc;
        }
    });
};

export { stopVideo };
